import script from "./AddCastrStream2.vue?vue&type=script&setup=true&lang=js"
export * from "./AddCastrStream2.vue?vue&type=script&setup=true&lang=js"

import "./AddCastrStream2.vue?vue&type=style&index=0&id=548f9915&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-548f9915"]])

export default __exports__